import { fetchConfig } from "~/core/global"
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector("form")
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this))
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer")
        this.submitButton = this.querySelector('[type="submit"]')
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog")
      }

      onSubmitHandler(evt) {
        evt.preventDefault()

        // if (document.querySelector('.add2cartBtn.not-available')) {
        //   window.location.href = window.location.origin + "/pages/contact"
        //   return
        // }

        if (this.submitButton.getAttribute("aria-disabled") === "true") return
        this.toggleCustomSelectErrorClass(false)
        this.handleErrorMessage()

        this.submitButton.setAttribute("aria-disabled", true)
        this.submitButton.classList.add("loading")
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden",
        )

        const config = fetchConfig("javascript")
        config.headers["X-Requested-With"] = "XMLHttpRequest"
        delete config.headers["Content-Type"]

        const formData = new FormData(this.form)
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          )
          formData.append("sections_url", window.location.pathname)
          this.cart.setActiveElement(document.activeElement)
        }
        config.body = formData

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.toggleCustomSelectErrorClass(false)
              this.handleErrorMessage(response.description, response)

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message")
              if (!soldOutMessage) return
              this.submitButton.setAttribute("aria-disabled", true)
              this.submitButton.querySelector("span").classList.add("hidden")
              soldOutMessage.classList.remove("hidden")
              this.error = true
              return
            } else if (!this.cart) {
              window.location = window.routes.cart_url
              return
            }

            this.error = false
            const quickAddModal = this.closest("quick-add-modal")
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response)
                  })
                },
                { once: true },
              )
              quickAddModal.hide(true)
            } else {
              this.cart.renderContents(response)
              // setTimeout(() => {
              //   this.cart.close()
              // }, 3000)
            }
          })
          .catch((e) => {
            console.error(e)
          })
          .finally(() => {
            this.submitButton.classList.remove("loading")
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty")
            if (!this.error) this.submitButton.removeAttribute("aria-disabled")
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden",
            )
          })
      }

      handleErrorMessage(errorMessage = false, fullResponse) {
        const errorMessageWrapper = this.querySelector(".product-form__error-message-wrapper")

        if (!fullResponse) return
        if (!errorMessageWrapper) return

        const { status } = fullResponse

        if (errorMessage) {
          if (status && status === 'bad_request') {
            this.toggleCustomSelectErrorClass(true)
          } else {
            errorMessageWrapper.toggleAttribute("hidden", !errorMessage)
            errorMessageWrapper.textContent = errorMessage
          }
        }
      }

      toggleCustomSelectErrorClass(error) {
        const sizeSelectWrapper = this.querySelector('.add2Cart_wishlist_wrapper .custom-select')

        if (sizeSelectWrapper === null) return

        if (!error && sizeSelectWrapper.classList.contains('error')) {
          sizeSelectWrapper.classList.remove('error')
        } else if (error && !sizeSelectWrapper.classList.contains('error')) {
          sizeSelectWrapper.classList.add('error')
        }
      }
    },
  )
}
